import { IProfileUpdateResponse, IRole, ITeam, IUserWithPhoto } from "../types/User.types";
import apiFetch from './index';

export async function isAuthenticated(): Promise<boolean> {
    const response = await apiFetch('/api/users/current/isAuthenticated');
    if (response.ok) {
        const text = await response.text();
        return text === "true";
    } else {
        return false;
    }
}

export async function getMyProfile(): Promise<IUserWithPhoto> {
    const response = await apiFetch('/api/users/me', {
            headers: {
            Accept: 'application/json',
        },
        credentials: 'include'
    });
    return await response.json();
}

export async function getUserProfile(id: number) {
    return await apiFetch('/api/users/' + id, {
            headers: {
            Accept: 'application/json',
        },
        credentials: 'include'
    });
}

export async function updateMyProfile(profile: IUserWithPhoto): Promise<IProfileUpdateResponse> {
    const response = await apiFetch('/api/users/me', {
        method: 'POST',
        body: JSON.stringify(profile),
        headers: {
            Accept: 'application/json',
            'Content-Type' : 'application/json'
        },
        credentials: 'include'
    });
    return await response.json();
}

export async function searchUsers(searchStr?: string): Promise<IUserWithPhoto[]> {
    if (!searchStr || searchStr.length < 3) return [];
    const response = await apiFetch('/api/users/search/' + encodeURIComponent(searchStr), {
        headers: {
            Accept: 'application/json',
            'Content-Type' : 'application/json'
        },
        credentials: 'include'
    });
    return await response.json();
}

export async function searchUsersByRole(roleId?: number, searchStr?: string): Promise<IUserWithPhoto[]> {
    if ((!searchStr || searchStr.length < 3) && roleId === undefined) return [];
    const params = new URLSearchParams();
    if (searchStr && searchStr.length >= 3) {
        params.append('searchStr', searchStr);
    }
    if (roleId !== undefined) {
        params.append('roleId', roleId.toString());
    }
    const response = await apiFetch('/api/users/search/filter?' + params.toString(), {
        headers: {
            Accept: 'application/json',
            'Content-Type' : 'application/json'
        },
        credentials: 'include'
    });
    return await response.json();
}

export async function searchTeams(searchStr?: string): Promise<ITeam[]> {
    if (!searchStr || searchStr.length < 3) return [];
    const response = await apiFetch('/api/users/searchTeams/' + encodeURIComponent(searchStr), {
        headers: {
            Accept: 'application/json',
            'Content-Type' : 'application/json'
        },
        credentials: 'include'
    });
    return await response.json();
}

export async function getRoles() {
    const response = await apiFetch(`/api/roles`);
    if (response.status === 200) {
        return await response.json() as IRole[];
    } else {
        return new Error("Unable to fetch roles");
    }
}

export async function saveRoles(email: string, roleIds: number[]): Promise<boolean> {
    const response = await apiFetch(`/api/users/${email}/roles`, {
        method: "POST",
        body: JSON.stringify({
            RoleIds: roleIds
        }),
        headers: {
            Accept: 'application/json',
            'Content-Type' : 'application/json'
        },
        credentials: 'include'
    }).catch((err) => err);
    return response.status === 200;
}

export async function loadAllTeams() {
    const response = await apiFetch('/api/teams', {
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include'
    });
    return response;
}
